import { render } from "./CounterDisplay.vue?vue&type=template&id=3393fb64&scoped=true"
import script from "./CounterDisplay.vue?vue&type=script&lang=js"
export * from "./CounterDisplay.vue?vue&type=script&lang=js"

import "./CounterDisplay.vue?vue&type=style&index=0&id=3393fb64&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3393fb64"]])

export default __exports__